var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"adminLink",class:{
    'adminLink--active': _vm.active,
    'adminLink--arrowbefore': _vm.arrow === 'before',
    'adminLink--arrowafter': _vm.arrow === 'after',
    'adminLink--button': _vm.button
  },attrs:{"to":_vm.to}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }